import React, { useState, useEffect, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button, Modal, Alert, Col, Row, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from "../../../services/api";
import Loading from '../Loading'
import { dateFormatter } from '../../../utils/dateFormatter'

import Highcharts from 'highcharts/highstock'

import styles from './UserEcg12.module.scss';
import * as CommonIcons from '../../CommonIcons';

import { OneIntervalChart } from './OneIntervalChart';

export default function UserEcg12({ apiEcg12BaseUrl }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [branchRecords, setBranchRecords] = useState([]);  

  useEffect(() => {
    const loadAvailableDates = () => {
      api
        .get(`${apiEcg12BaseUrl}/available-dates`)
        .then((response) => {          
          setBranchRecords(response.data.items);                   
          setLoading(false);
        });
    };

    loadAvailableDates();
    
  }, [apiEcg12BaseUrl]); 


  if (loading)
    return <Loading />;

  return (
    <>
    <div className={styles.ecg12Table}>
        {branchRecords.map(branch => {
          return (
            <div key={branch.branchType} className={`${styles.oneChart}`}>              
              <OneIntervalChart
                displayName={branch.displayName}
                branchType={branch.branchType}
                availableRecords={branch.availableRecords}                
                apiUrl={`${apiEcg12BaseUrl}/record`}
                containerClassName={styles.oneChartContainer}
              />
            </div>
        )
      }) }
    </div>
    </>
  );
}